import { defaultPageTitle } from '../template';

export const replaceState = path => {
	window.history.replaceState(null, null,
		window.location.pathname.indexOf('/root-100-2019') > -1 ?
		window.location.pathname.replace(/\/root-100-2019\/[^\/]*\/?$/, `/root-100-2019${path}`) :
		window.location.pathname.replace(/\/[^\/]*\/?$/, `${path}`)
	);
};

export const setPageTitle = name => {
	const titleElement = document.querySelector('title');
	if (titleElement) {
		titleElement.innerText = name ? `${name} | ${defaultPageTitle}` : defaultPageTitle;
	}
};


// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/helpers.js